export const putOrganizationChartLeadersIS = {
	data: undefined,
	loading: false,
	error: null,
	errorShow: false,
};
